export function extractColorTextPairs(input: string) {
  const results: { color: string; text: string }[] = []
  const { length } = input

  for (let i = 0; i < length; i += 1) {
    if (input[i] !== '[') continue

    const colorStart = i + 1
    let colorEnd = -1

    for (let j = colorStart; j < length; j += 1) {
      if (input[j] !== ']') continue

      colorEnd = j
      break
    }

    if (colorEnd === -1 || input[colorEnd + 1] !== '(') continue

    const color = input.slice(colorStart, colorEnd)
    const textStart = colorEnd + 2
    let openParenthesis = 1
    let textEnd = -1

    for (let k = textStart; k < length; k += 1) {
      if (input[k] === '(') openParenthesis += 1
      else if (input[k] === ')') openParenthesis -= 1

      if (openParenthesis === 0) {
        textEnd = k
        break
      }
    }

    if (textEnd !== -1) {
      const text = input.slice(textStart, textEnd)
      results.push({ color, text })
      i = textEnd
    }
  }

  return results
}
